import React, { useCallback, useContext, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import TrendingDestinations from '../../components/TrendingDestinations/TrendingDestinations'
import Search from '../../components/Search/Search'
import Pane from 'components/Common/Pane'
import { selectLoggedIn } from 'selectors/accountSelectors'
import HeroOfferCarouselSection from '../../components/OfferCarousels/HeroOfferCarouselSection'
import HotelOfferCarousel from '../../components/OfferCarousels/HotelOfferCarousel'
import TourOfferCarousel from '../../components/OfferCarousels/TourOfferCarousel'
import ValuePropositionBanner from '../../components/ValuePropositionBanner/ValuePropositionBanner'
import MarketingCarousel from '../../components/MarketingCarousel/MarketingCarousel'
import BlogCarousel from '../../components/Blog/BlogCarousel'
import BrowseOfferTypes from 'home/components/BrowseOfferTypes/BrowseOfferTypes'
import SmartExperienceOfferCarousel from 'home/components/OfferCarousels/ExperienceOfferCarousel/SmartExperienceOfferCarousel'
import GeoContext from 'contexts/geoContext'
import UltraLuxOfferCarousel from 'home/components/OfferCarousels/UltraLuxHotelOfferCarousel'
import config from 'constants/config'
import TopPicksForMeCarousel from 'home/components/OfferCarousels/TopPicksForMeCarousel'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import useHomepageAnalytics from 'home/pages/HomePage/useHomepageAnalytics'
import { rem } from 'polished'
import styled from 'styled-components'
import { GlobalSearchTrackingProvider } from 'contexts/GlobalSearch/GlobalSearchTracking'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import { isStandaloneCruiseEnabled } from 'selectors/cruiseOfferSelectors'
import FrontPageUSPComponent from 'components/Pages/FrontPage/USP/FrontPageUSPComponent'
import Divider from 'LuxKit/Divider'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Trip from 'home/components/Trip'
import SupportTile from 'components/Common/SupportTile/SupportTile'
import { HOMEPAGE_EUROPE_INSPIRATION_BANNERS_REGIONS, NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import useQueryParams from 'hooks/useQueryParams'
import LuxPlusOfferCarousel from 'home/components/OfferCarousels/LuxPlusOfferCarousel'
import { getCanRedeemLuxPlusBenefits, getIsEnabledLuxPlusDiscountedExperiences, getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import RequestAgentCallbackModal from 'supportAssistant/components/RequestAgentCallback/Modals/RequestAgentCallbackModal'
import ModalContext from 'contexts/ModalContext'
import { removeSearchParamValue } from 'lib/url/searchUrlUtils'
import { replace } from 'connected-react-router'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useLocation } from 'react-router'
import CompactBookingDetailsUpsellSection from 'checkout/Components/Confirmation/BookingDetailsV2/CompactBookingDetailsUpsellSection'
import { fetchOrders } from 'actions/OrderActions'
import { haveOrdersBeenFetched, sortOrdersByDeparture } from 'lib/order/orderUtils'
import { getUpcomingOrders } from 'selectors/orderSelectors'
import { upsellEnabledForOrder } from 'lib/order/upsellUtils'
import OfferDetailUpsellSection from 'checkout/Components/Confirmation/BookingDetailsV2/OfferDetailUpsellSection'
import Group from 'components/utils/Group'
import EuropeInspirationBannerSection from 'home/components/EuropeInspirationBannerSection/EuropeInspirationBannerSection'
import { REQUEST_SALES_CALLBACK_PATH, REQUEST_SUPPORT_CALLBACK_PATH } from 'supportAssistant/components/RequestAgentCallback/RequestAgentCallbackUtils'
import RecentSearches from 'home/components/RecentSearches/RecentSearches'
import { TERMS_AND_CONDITIONS_ACKNOWLEDGED_PATH } from 'home/constants'
import TermsAndConditionsAcknowledgedModal from 'components/App/TermsAndConditionsModal/TermsAndConditionsAcknowledgedModal'
import { OptimizelyFeatureFlags, OptimizelyExperiments } from 'constants/optimizely'
import useOfferList from 'hooks/Offers/useOfferList'
import { interleaveWithRatio, skip, take, unique, without } from 'lib/array/arrayUtils'
import { getHomeOfferListParams, getToursOfferListFilters, hasRecentTourViews } from 'home/helpers'
import useOrderItemsEligibleForCarHireBundle from 'hooks/CarHire/useOrderItemsEligibleForCarHireBundle'
import CarHireBundledUpcomingOrderCondensed from 'components/CarHire/CarHireBundledUpcomingOrders/CarHireBundledUpcomingOrderCondensed'
import { isCarHireBundledHomepageCarouselEnabled } from 'selectors/carHireSelectors'
import Leaderboard from 'components/Common/Banner/Leaderboard'
import { fetchBanners } from 'actions/ContentActions'
import { BANNER_LOCATION_HOME } from 'constants/bannerLocations'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { selectAlternativesOfferListFilters, selectTwoTowerOfferListFiltersByUser } from 'selectors/recommendations'
import CruiseOfferCarousel from 'home/components/OfferCarousels/CruiseOfferCarousel'
import ExperienceLuxPlusCarousel from 'components/Experiences/ExperienceLists/ExperienceLuxPlusCarousel'
import ComponentBannerGroup from 'marketing/components/ComponentBannerGroup'
import { useUserInteractions } from 'hooks/Recommendation/useUserInteractions'
import { isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'
import useCurrentSiteTakeover from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import LuxPlusMonthHeroSubtitleAltContent from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthHeroSubtitleAltContent'
import { LUX_PLUS_MONTH_TAKEOVER_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import { ALTERNATIVES_RECENTLY_VIEWED_LIMIT } from 'components/Recommendations/common/constant'

const EMPTY_BANNERS: Array<App.Banner> = []

const LeaderboardLayoutContainer = styled(Pane)`
  padding-top: ${rem(12)};
  position: relative;

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(40)};
  }
`

const HomepageSection = styled(LayoutContainer)`
  padding-top: ${rem(40)};
`

const CarHireCarouselSection = styled.div`
  padding-top: ${rem(40)};
`

interface MappedProps {
  banners?: Array<App.Banner>;
  isLoggedIn: boolean;
  isStandaloneCruiseEnabled: boolean;
  isLuxPlusEnabled: boolean;
  canRedeemLuxPlusBenefits: boolean;
  carHireBundledCarouselEnabled: boolean;
  isLuxPlusExperiencesEnabled: boolean;
}

function HomePage(props: MappedProps) {
  const {
    isLoggedIn,
    isStandaloneCruiseEnabled,
    isLuxPlusEnabled,
    canRedeemLuxPlusBenefits,
    carHireBundledCarouselEnabled,
    banners,
    isLuxPlusExperiencesEnabled,
  } = props
  const query = useQueryParams()
  const showSupportCallbacksModal = query.has(REQUEST_SUPPORT_CALLBACK_PATH)
  const showSalesCallbacksModal = query.has(REQUEST_SALES_CALLBACK_PATH)
  const { currentRegionCode, geoStateName } = useContext(GeoContext)
  const ordersFetched = useAppSelector((state) => haveOrdersBeenFetched(state, 'upcoming'))
  const upcomingOrders = useAppSelector((state) => getUpcomingOrders(state))

  const showSupportContainer = !NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode)
  const upsellTilesFeatureToggle = !!useOptimizelyExperiment(OptimizelyFeatureFlags.upsellTilesFeatureToggle)
  const showEuropeInspirationBanners = HOMEPAGE_EUROPE_INSPIRATION_BANNERS_REGIONS.includes(currentRegionCode)
  const showFrontPageUSP = !isLoggedIn && !showEuropeInspirationBanners
  const hideHomepageSearch = !!useOptimizelyExperiment(OptimizelyExperiments.croHideHomepageSearchEmergingMarkets)
  const termsAndConditionsAcknowledgedCartId = query.get(TERMS_AND_CONDITIONS_ACKNOWLEDGED_PATH)

  const { search } = useLocation()
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()

  const handleRequestAgentCallbackModal = useCallback((callbackType: App.GenesysAgentCallbackType, callbackPath: string) => {
    showModal(<RequestAgentCallbackModal type={callbackType} />)

    const nextSearch = removeSearchParamValue(search, callbackPath, 'true')
    dispatch(replace({ search: nextSearch }))
  }, [dispatch, search, showModal])

  useEffect(() => {
    if (showSalesCallbacksModal) {
      handleRequestAgentCallbackModal('SALES', REQUEST_SALES_CALLBACK_PATH)
    } else if (showSupportCallbacksModal) {
      handleRequestAgentCallbackModal('SUPPORT', REQUEST_SUPPORT_CALLBACK_PATH)
    }
  }, [dispatch, search, showSupportCallbacksModal, showSalesCallbacksModal, showModal, handleRequestAgentCallbackModal])

  useEffect(() => {
    if (termsAndConditionsAcknowledgedCartId) {
      showModal(<TermsAndConditionsAcknowledgedModal cartId={termsAndConditionsAcknowledgedCartId} />)

      const nextSearch = removeSearchParamValue(search, TERMS_AND_CONDITIONS_ACKNOWLEDGED_PATH, 'true')
      dispatch(replace({ search: nextSearch }))
    }
  }, [termsAndConditionsAcknowledgedCartId, showModal, dispatch, search])

  useEffect(() => {
    if (!ordersFetched) {
      dispatch(fetchOrders({ status: 'upcoming' }))
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    dispatch(fetchBanners(BANNER_LOCATION_HOME))
  }, [dispatch])
  const bannersAboveHero = useMemo(() =>
    banners?.filter((banner) => banner.position === 'homepage-above-hero-carousel'),
  [banners],
  )

  const bannersBelowHero = useMemo(() =>
    banners?.filter((banner) => banner.position === 'homepage-below-search-bar'),
  [banners],
  )

  const upsellOrder = useMemo(() => {
    return sortOrdersByDeparture(upcomingOrders)
      .find(upsellEnabledForOrder)
  }, [upcomingOrders])

  const showUpsellSection = ordersFetched &&
    upsellTilesFeatureToggle &&
    !!upsellOrder

  const {
    onTourListEvent,
    onCruiseListEvent,
    onHotelListEvent,
    onBestValueHotelListEvent,
    onUltraLuxListEvent,
    onHeroListEvent,
    onSearchEvent,
    onTrendingDestinationsListEvent,
    onExperienceListEvent,
    onTPFMListEvent,
    onTripOfferListEvent,
    onLuxPlusListEvent,
  } = useHomepageAnalytics()

  const { earliestItem } = useOrderItemsEligibleForCarHireBundle(upsellOrder?.id)
  const showBundledCarHireCarousel = showUpsellSection && carHireBundledCarouselEnabled && !!earliestItem && !!upsellOrder?.hasCarHireIntention

  /** START: Lere Hero Carousel */
  const heroOffers = useOfferList({
    ...getHomeOfferListParams({
      region: currentRegionCode,
      subregion: geoStateName,
    }),
  })
  const lereHeroCarouselEnabled: boolean = !!useOptimizelyExperiment(OptimizelyFeatureFlags.lereHeroCarouselEnabled)
  const twoTowersOfferListFilters = useAppSelector(selectTwoTowerOfferListFiltersByUser)
  const twoTowersOfferList = useOfferList(twoTowersOfferListFilters, { disabled: !lereHeroCarouselEnabled })
  const alternativesOfferListFilters = useAppSelector(selectAlternativesOfferListFilters)
  const alternativesOfferList = useOfferList(alternativesOfferListFilters, { disabled: !lereHeroCarouselEnabled })
  const [userPageViewsLast7DaysInteractions, userPageViewsLast7DaysFetching] = useUserInteractions({ interactionType: 'view', sinceDaysAgo: 7, disabled: !lereHeroCarouselEnabled })

  const isToursManualSortingEnabled = isManualSortingEnabledFor('tours')
  const toursOfferListFilters = useMemo(() => getToursOfferListFilters(isToursManualSortingEnabled), [isToursManualSortingEnabled])
  const toursOfferList = useOfferList(toursOfferListFilters)
  const highIntentOffers = useAppSelector(state => state.recommendations.highIntent)

  const interleaveOfferListWithTours = useCallback((offerList: App.OfferList): [App.OfferList, Array<string>] => {
    const fetching = highIntentOffers.state === 'loading' || offerList.fetching
    const hasTourView = hasRecentTourViews(
      take(highIntentOffers.offers, ALTERNATIVES_RECENTLY_VIEWED_LIMIT)
    )

    // Skip interleaving if no offers or no recent tour view in the last 7 offer views
    if (!offerList.offerIds.length || !hasTourView) {
      return [{ ...offerList, fetching }, []]
    }

    const toursToInterleave: Array<string> = take(toursOfferList.offerIds, 3)
    const offerListOfferIdsSkipFirst = skip(offerList.offerIds, 1)

    return [
      {
        ...offerList,
        fetching,
        // hotel, tour, hotel, hotel, tour, ...
        offerIds: [offerList.offerIds[0], ...interleaveWithRatio(toursToInterleave, offerListOfferIdsSkipFirst, { antecedent: 1, consequent: 2 })],
      },
      toursToInterleave,
    ]
  }, [highIntentOffers, toursOfferList])
  // The excludedTourIds would be the same for both offer lists
  const [interleavedTwoTowersOfferList, excludedTourIds] = interleaveOfferListWithTours(twoTowersOfferList)
  const [interleavedAlternativesOfferList, _] = interleaveOfferListWithTours(alternativesOfferList)

  const twoTowersNonAUHeroCarouselEnabled = !!useOptimizelyExperiment(
    OptimizelyExperiments.lereNonAUTwoTowersHomePageHeroCarouselV2,
    lereHeroCarouselEnabled &&
    interleavedTwoTowersOfferList.offerIds.length >= 9 &&
    !!userPageViewsLast7DaysInteractions.length &&
    currentRegionCode !== 'AU'
  )
  const twoTowersAUHeroCarouselEnabled = !!useOptimizelyExperiment(
    OptimizelyExperiments.lereTwoTowersHomePageHeroCarouselV3,
    lereHeroCarouselEnabled &&
    interleavedTwoTowersOfferList.offerIds.length >= 9 &&
    interleavedAlternativesOfferList.offerIds.length >= 9 &&
    currentRegionCode === 'AU'
  )
  const alternativesHeroCarouselEnabled = lereHeroCarouselEnabled && interleavedAlternativesOfferList.offerIds.length >= 9 && currentRegionCode === 'AU'
  /** END: Lere Hero Carousel */

  const alternateHomepageOrderEnabled = !!useOptimizelyExperiment(OptimizelyExperiments.croAlternateHomepageOrder)

  const currentSiteTakeover = useCurrentSiteTakeover()
  const isLuxPlusMonthTakeover = currentSiteTakeover?.id === LUX_PLUS_MONTH_TAKEOVER_ID

  const carouselOverrides = useMemo(() => {
    let heroCarouselOfferList: App.OfferList | undefined
    let heroCarouselTitle: React.ReactNode | undefined
    let heroCarouselSubtitle: React.ReactNode | undefined
    let tpfmCarouselOfferList: App.OfferList | undefined
    let tpfmCarouselTitle: React.ReactNode | undefined

    const topPicksForYouTitle = <>Top picks for <i>you</i></>
    const todaysTopExclusiveOffersTitle = <>Today's top <i>exclusive</i> offers</>

    // Force loading state for all carousels until ALL offerLists have finished fetching
    if (heroOffers.fetching || interleavedAlternativesOfferList.fetching || interleavedTwoTowersOfferList.fetching || userPageViewsLast7DaysFetching) {
      const placeholderOfferList: App.OfferList = { offerIds: [], fetching: true, key: 'placeholder-offer-list' }
      heroCarouselOfferList = placeholderOfferList
      tpfmCarouselOfferList = placeholderOfferList
    }

    if (twoTowersAUHeroCarouselEnabled) {
      const firstCuratedOffer = heroOffers.offerIds[0]
      heroCarouselOfferList = { ...interleavedTwoTowersOfferList, offerIds: unique([firstCuratedOffer, ...interleavedTwoTowersOfferList.offerIds]) }
      heroCarouselTitle = topPicksForYouTitle
      if (isLuxPlusMonthTakeover) {
        heroCarouselSubtitle = <LuxPlusMonthHeroSubtitleAltContent />
      }
      tpfmCarouselOfferList = { ...heroOffers, offerIds: without(heroOffers.offerIds, firstCuratedOffer) }
      tpfmCarouselTitle = todaysTopExclusiveOffersTitle
    }
    else if (twoTowersNonAUHeroCarouselEnabled) {
      const firstCuratedOffer = heroOffers.offerIds[0]
      heroCarouselOfferList = { ...twoTowersOfferList, offerIds: unique([firstCuratedOffer, ...twoTowersOfferList.offerIds]) }
      heroCarouselTitle = topPicksForYouTitle
      if (isLuxPlusMonthTakeover) {
        heroCarouselSubtitle = <LuxPlusMonthHeroSubtitleAltContent />
      }
      tpfmCarouselOfferList = { ...heroOffers, offerIds: without(heroOffers.offerIds, firstCuratedOffer) }
      tpfmCarouselTitle = todaysTopExclusiveOffersTitle
    }
    else if (alternativesHeroCarouselEnabled) {
      const firstCuratedOffer = heroOffers.offerIds[0]
      heroCarouselOfferList = { ...interleavedAlternativesOfferList, offerIds: unique([firstCuratedOffer, ...interleavedAlternativesOfferList.offerIds]) }
      heroCarouselTitle = topPicksForYouTitle
      if (isLuxPlusMonthTakeover) {
        heroCarouselSubtitle = <LuxPlusMonthHeroSubtitleAltContent />
      }
      tpfmCarouselOfferList = { ...heroOffers, offerIds: without(heroOffers.offerIds, firstCuratedOffer) }
      tpfmCarouselTitle = todaysTopExclusiveOffersTitle
    }

    return {
      heroCarouselOfferList,
      heroCarouselTitle,
      heroCarouselSubtitle,
      tpfmCarouselOfferList,
      tpfmCarouselTitle,
    }
  }, [
    heroOffers,
    interleavedAlternativesOfferList,
    interleavedTwoTowersOfferList,
    userPageViewsLast7DaysFetching,
    isLuxPlusMonthTakeover,
    alternativesHeroCarouselEnabled,
    twoTowersAUHeroCarouselEnabled,
    twoTowersNonAUHeroCarouselEnabled,
    twoTowersOfferList
  ])

  if (alternateHomepageOrderEnabled) {
    return (
      <AnalyticsPageContext.Provider value={AnalyticsPage.homepage}>
        <Pane>
          <ErrorBoundary fallback={null}>
            <PromptCardSelector tripReengagement carHire />
          </ErrorBoundary>
          <OfferListEventsProvider onListEvent={onHeroListEvent}>
            {bannersAboveHero && bannersAboveHero?.length > 0 && (
              <LeaderboardLayoutContainer paletteType="inverse">
                <LayoutContainer>
                  <Leaderboard banners={bannersAboveHero || EMPTY_BANNERS} />
                </LayoutContainer>
              </LeaderboardLayoutContainer>
            )}
            <HeroOfferCarouselSection
              overrideTitle={carouselOverrides.heroCarouselTitle}
              overrideSubtitle={carouselOverrides.heroCarouselSubtitle}
              overrideOfferList={carouselOverrides.heroCarouselOfferList}
            />
          </OfferListEventsProvider>
          {!hideHomepageSearch && (
            <GlobalSearchTrackingProvider onEvent={onSearchEvent}>
              <Search />
            </GlobalSearchTrackingProvider>
          )}
          <ComponentBannerGroup slug="homepage-banner-position-one" />
          {bannersBelowHero && bannersBelowHero?.length > 0 && (
            <LeaderboardLayoutContainer>
              <LayoutContainer>
                <Leaderboard banners={bannersBelowHero || EMPTY_BANNERS} />
              </LayoutContainer>
            </LeaderboardLayoutContainer>
          )}
          {showUpsellSection && (
            <HomepageSection>
              <Group direction="vertical" gap={32}>
                <OfferDetailUpsellSection order={upsellOrder} />
                <CompactBookingDetailsUpsellSection order={upsellOrder} />
              </Group>
            </HomepageSection>
          )}
          {showEuropeInspirationBanners && <EuropeInspirationBannerSection />}
          {showFrontPageUSP && (
            <HomepageSection>
              <VerticalSpacer gap={40}>
                <FrontPageUSPComponent />
                <Divider kind="primary" />
              </VerticalSpacer>
            </HomepageSection>
          )}
          <RecentSearches />
          {isLoggedIn && !showUpsellSection && config.TRIP_PLANNER_ENABLE_HOMEPAGE_MODULE && (
            <OfferListEventsProvider onListEvent={onTripOfferListEvent}>
              <Trip />
            </OfferListEventsProvider>
          )}
          {showBundledCarHireCarousel && (
            <CarHireCarouselSection>
              <CarHireBundledUpcomingOrderCondensed order={upsellOrder} />
            </CarHireCarouselSection>
          )}
          <OfferListEventsProvider onListEvent={onTrendingDestinationsListEvent}>
            <TrendingDestinations />
          </OfferListEventsProvider>
          {!isAgentHubEnabled && (
            <OfferListEventsProvider onListEvent={onTPFMListEvent}>
              <TopPicksForMeCarousel
                onHotelListEvent={onHotelListEvent}
                overrideTitle={carouselOverrides.tpfmCarouselTitle}
                overrideOfferList={carouselOverrides.tpfmCarouselOfferList}
              />
            </OfferListEventsProvider>
          )}
          <OfferListEventsProvider onListEvent={onTourListEvent}>
            <TourOfferCarousel excludedIds={excludedTourIds} />
          </OfferListEventsProvider>
          {showSupportContainer && (
            <LayoutContainer>
              <SupportTile />
            </LayoutContainer>
          )}
          {isStandaloneCruiseEnabled && (
            <OfferListEventsProvider onListEvent={onCruiseListEvent}>
              <CruiseOfferCarousel />
            </OfferListEventsProvider>
          )}
          {!isLoggedIn && (
            <LayoutContainer>
              <VerticalSpacer gap={40}>
                <Divider kind="primary" />
                <TrustIndicatorSection />
                <Divider kind="primary" />
              </VerticalSpacer>
            </LayoutContainer>
          )}
          <OfferListEventsProvider onListEvent={onExperienceListEvent}>
            {isLuxPlusEnabled && canRedeemLuxPlusBenefits && <ExperienceLuxPlusCarousel />}
            {(!isLuxPlusEnabled || !canRedeemLuxPlusBenefits) && <SmartExperienceOfferCarousel />}
          </OfferListEventsProvider>
          <MarketingCarousel />
          {isLuxPlusEnabled && (
            <OfferListEventsProvider onListEvent={onLuxPlusListEvent}>
              <LuxPlusOfferCarousel />
            </OfferListEventsProvider>
          )}
          <OfferListEventsProvider onListEvent={onBestValueHotelListEvent}>
            <HotelOfferCarousel sortBy="value" streamList />
          </OfferListEventsProvider>
          {config.ULTRALUX_ENABLED && (
            <OfferListEventsProvider onListEvent={onUltraLuxListEvent}>
              <UltraLuxOfferCarousel />
            </OfferListEventsProvider>
          )}
          <ValuePropositionBanner />
          <BlogCarousel />
          <BrowseOfferTypes />
        </Pane>
      </AnalyticsPageContext.Provider>
    )
  }

  return (
    <AnalyticsPageContext.Provider value={AnalyticsPage.homepage}>
      <Pane>
        <ErrorBoundary fallback={null}>
          <PromptCardSelector tripReengagement carHire />
        </ErrorBoundary>
        <OfferListEventsProvider onListEvent={onHeroListEvent}>
          {bannersAboveHero && bannersAboveHero?.length > 0 && (
            <LeaderboardLayoutContainer paletteType="inverse">
              <LayoutContainer>
                <Leaderboard banners={bannersAboveHero || EMPTY_BANNERS} />
              </LayoutContainer>
            </LeaderboardLayoutContainer>
          )}
          <HeroOfferCarouselSection
            overrideTitle={carouselOverrides.heroCarouselTitle}
            overrideSubtitle={carouselOverrides.heroCarouselSubtitle}
            overrideOfferList={carouselOverrides.heroCarouselOfferList}
          />
        </OfferListEventsProvider>
        {!hideHomepageSearch && (
          <GlobalSearchTrackingProvider onEvent={onSearchEvent}>
            <Search />
          </GlobalSearchTrackingProvider>
        )}
        <ComponentBannerGroup slug="homepage-banner-position-one" />
        {bannersBelowHero && bannersBelowHero?.length > 0 && (
          <LeaderboardLayoutContainer>
            <LayoutContainer>
              <Leaderboard banners={bannersBelowHero || EMPTY_BANNERS} />
            </LayoutContainer>
          </LeaderboardLayoutContainer>
        )}
        {showUpsellSection &&
          <HomepageSection>
            <Group direction="vertical" gap={32}>
              <OfferDetailUpsellSection order={upsellOrder} />
              <CompactBookingDetailsUpsellSection order={upsellOrder} />
            </Group>
          </HomepageSection>}

        {showBundledCarHireCarousel && <CarHireCarouselSection>
          <CarHireBundledUpcomingOrderCondensed order={upsellOrder} />
        </CarHireCarouselSection>}

        {showEuropeInspirationBanners && <EuropeInspirationBannerSection />}
        {showFrontPageUSP && <HomepageSection>
          <VerticalSpacer gap={40}>
            <FrontPageUSPComponent />
            <Divider kind="primary" />
          </VerticalSpacer>
        </HomepageSection>}
        {isLoggedIn && !showUpsellSection && config.TRIP_PLANNER_ENABLE_HOMEPAGE_MODULE && (
          <OfferListEventsProvider onListEvent={onTripOfferListEvent}>
            <Trip />
          </OfferListEventsProvider>
        )}
        {isLuxPlusEnabled && canRedeemLuxPlusBenefits && <OfferListEventsProvider onListEvent={onLuxPlusListEvent}>
          <LuxPlusOfferCarousel />
        </OfferListEventsProvider>}
        <OfferListEventsProvider onListEvent={onTrendingDestinationsListEvent}>
          <TrendingDestinations />
        </OfferListEventsProvider>
        {!isLoggedIn && <LayoutContainer>
          <VerticalSpacer gap={40}>
            <Divider kind="primary" />
            <TrustIndicatorSection />
            <Divider kind="primary" />
          </VerticalSpacer>
        </LayoutContainer>}
        <RecentSearches />
        {!isAgentHubEnabled && (
          <OfferListEventsProvider onListEvent={onTPFMListEvent}>
            <TopPicksForMeCarousel
              onHotelListEvent={onHotelListEvent}
              overrideTitle={carouselOverrides.tpfmCarouselTitle}
              overrideOfferList={carouselOverrides.tpfmCarouselOfferList}
            />
          </OfferListEventsProvider>
        )}
        {isLuxPlusEnabled && !canRedeemLuxPlusBenefits && <OfferListEventsProvider onListEvent={onLuxPlusListEvent}>
          <LuxPlusOfferCarousel />
        </OfferListEventsProvider>}
        {isLuxPlusExperiencesEnabled && <OfferListEventsProvider onListEvent={onExperienceListEvent}>
          <ExperienceLuxPlusCarousel />
        </OfferListEventsProvider>}
        <OfferListEventsProvider onListEvent={onTourListEvent}>
          <TourOfferCarousel excludedIds={excludedTourIds} />
        </OfferListEventsProvider>
        <OfferListEventsProvider onListEvent={onBestValueHotelListEvent}>
          <HotelOfferCarousel sortBy="value" streamList />
        </OfferListEventsProvider>
        {isStandaloneCruiseEnabled && (
          <OfferListEventsProvider onListEvent={onCruiseListEvent}>
            <CruiseOfferCarousel />
          </OfferListEventsProvider>
        )}
        <MarketingCarousel />
        {isLoggedIn && <OfferListEventsProvider onListEvent={onHotelListEvent}>
          <HotelOfferCarousel />
        </OfferListEventsProvider>}
        {showSupportContainer && <LayoutContainer>
          <SupportTile />
        </LayoutContainer>}
        {config.ULTRALUX_ENABLED && (
          <OfferListEventsProvider onListEvent={onUltraLuxListEvent}>
            <UltraLuxOfferCarousel />
          </OfferListEventsProvider>
        )}
        <OfferListEventsProvider onListEvent={onExperienceListEvent}>
          <SmartExperienceOfferCarousel />
        </OfferListEventsProvider>
        <ValuePropositionBanner />
        <BlogCarousel />
        <BrowseOfferTypes />
      </Pane>
    </AnalyticsPageContext.Provider>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    banners: state.content.banners.home,
    isLoggedIn: selectLoggedIn(state),
    isStandaloneCruiseEnabled: isStandaloneCruiseEnabled(state),
    isLuxPlusEnabled: getIsLuxPlusEnabled(state),
    canRedeemLuxPlusBenefits: getCanRedeemLuxPlusBenefits(state),
    carHireBundledCarouselEnabled: isCarHireBundledHomepageCarouselEnabled(state),
    isLuxPlusExperiencesEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(HomePage)
